import React, { useEffect, useState } from 'react';
import { Box, Grid, Button, Typography, Card, Skeleton, Container, IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { PictureAsPdf } from '@material-ui/icons';
import { DialogAnimate } from 'src/components/animate';
import { REST_API } from 'src/constants/Defaultvalues';

export default function InvoicePdfPreviewPage({ invoice }) {
  const theme = useTheme();
  const [pdfs, setPdfs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
  const [currentPdfPath, setCurrentPdfPath] = useState('');  // State to hold the current PDF path

  useEffect(() => {
    if (invoice?.sign_agreements) {
      // Filter out sign agreements that have a valid PDF path
      const filteredPdfs = invoice.sign_agreements
        .filter(agr => agr.agreement_pdf_path || agr.attachment) // Check if either agreement_pdf_path or attachment is not null
        .map(agr => {
          let pdfPath = agr.agreement_pdf_path || agr.attachment;
          if (pdfPath && !pdfPath.startsWith('http')) {
            pdfPath = `${REST_API}${pdfPath}`;
          }
          return {
            name: agr.name,
            pdfPath: pdfPath,
          };
        });
      setPdfs(filteredPdfs);
      setLoading(false);
    }
  }, [invoice]);

  const handleOpenModal = (pdfPath) => {
    setCurrentPdfPath(pdfPath);  // Set the current PDF path
    setOpenAttachmentModal(true);
    setPdfLoading(true);
    setTimeout(() => setPdfLoading(false), 2500); // Simulate loading delay
  };

  return (
    <Container>
      <Box sx={{ mt: 1 }}>
        <Grid container spacing={3} sx={{ mt: 3 }}>
          {loading ? (
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="100%" height={400} />
            </Grid>
          ) : (
            pdfs.map((pdf, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card sx={{ position: 'relative', p: 2, backgroundColor: '#454F5B', borderRadius: '16px' }}>
                  <Box sx={{ position: 'relative' }}>
                    <iframe
                      src={pdf.pdfPath} // Load the PDF in a normal iframe
                      width="100%"
                      height="300"
                      frameBorder="0"
                      style={{ display: pdfLoading ? 'none' : 'block', borderRadius: '8px' }}
                      onLoad={() => setPdfLoading(false)}
                      title={`pdf-preview-${index}`}
                    />
                    <IconButton
                      onClick={() => handleOpenModal(pdf.pdfPath)}
                      aria-label="view pdf"
                      sx={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 2,
                        color: theme.palette.error.main,
                        backgroundColor: theme.palette.text.primary,
                      }}
                    >
                      <PictureAsPdf style={{ fontSize: 40 }} />
                    </IconButton>
                    <Typography variant="subtitle2" sx={{ mt: 2.5, textAlign: 'left', fontWeight: 'bold', display: 'inline-flex', flexDirection: 'row', alignItems: 'center', gap: 0.5 }}>
                      <PictureAsPdf style={{ fontSize: 20 }} />
                      {pdf.name}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))
          )}
        </Grid>
      </Box>

      {/* Modal to show PDF preview */}
      <DialogAnimate open={openAttachmentModal} onClose={() => setOpenAttachmentModal(false)}>
        <Card sx={{ p: 3, maxWidth: 768, margin: 'auto', display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden' }}>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginBottom: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => window.open(currentPdfPath, '_blank')}  // Open PDF in a new tab
              disabled={!currentPdfPath}
              startIcon={<PictureAsPdf style={{ fontSize: 20 }} />}
              sx={{ fontSize: '14px' }}
            >
              View PDF
            </Button>
          </Box>
          <Box sx={{ width: '100%', minHeight: 500, position: 'relative' }}>
            {pdfLoading && (
              <Skeleton variant="rectangular" width="100%" height={500} sx={{ position: 'absolute', top: 0, left: 0 }} />
            )}
            {currentPdfPath && (
              <iframe
                src={currentPdfPath}  // Display the PDF in iframe
                title="Selected PDF"
                width="100%"
                height="500"
                frameBorder="0"
                style={{ display: pdfLoading ? 'none' : 'block', border: 'none' }}
                onLoad={() => setPdfLoading(false)}
              />
            )}
          </Box>
        </Card>
      </DialogAnimate>
    </Container>
  );
}